import React from 'react'

import Grid, { Col } from '../../../../components/pdf/Grid'
import Image from '../../../../components/pdf/Image'
import Separator from '../../../../components/pdf/Separator'
import Text from '../../../../components/pdf/Text'

const Header = () => (
  <>
    <Grid justify="end" align="center">
      <Col>
        <Text size="xsmall">Powered by</Text>
      </Col>
      <Col gutter={10}>
        <Image src="/btime-logo-roxo.png" maxWidth={50} ignoreFixedSize />
      </Col>
      <Col>
        <Image style={{ width: '20px' }} src="/pdfs/srsms/srsms.png" maxWidth={20} ignoreFixedSize />
      </Col>
    </Grid>
    <Separator weight={0} />
  </>
)

export default Header
